import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Chat, Like } from '@peacecover/icon';
import { useGetInstagramPost } from '../../domains/instagram/ui/hooks/useGetInstagramPost';
import { formatDateTime } from '../../utils/DateUtil';
import ProfileAvatar from '../my-page/components/ProfileAvatar';
import CommonHeader from '../components/bar/CommonHeader';
import type { components } from '../../types/schema';

// @ts-expect-error - ApiV1PersonaInstagramPost not yet in schema
type Post = components['schemas']['ApiV1PersonaInstagramPost'];

const InstagramDetailPage = () => {
  const { postId } = useParams<{ postId: string }>();

  const { data: post } = useGetInstagramPost(postId ?? '');

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-light dark:bg-background-dark">
      <Helmet>
        <title>{post?.authorId ? `${post.authorId}님의 게시물` : '게시물'}</title>
      </Helmet>
      <CommonHeader title="게시물" />
      <div className="h-[44px] w-full" />
      {post && <PostItem post={post} />}
    </div>
  );
};

export default InstagramDetailPage;

interface PostItemProps {
  post: Post;
}

const PostItem = ({ post }: PostItemProps) => {
  return (
    <div className="flex flex-col">
      <div className="p-[16px] flex items-center gap-[8px]">
        <ProfileAvatar
          thumbnailUrl={post.profileImageUrl}
          widthAndHeight="40px"
          svgWidthAndHeight="40px"
        />
        <div className="flex flex-col items-start gap-[5px]">
          <p className="text-[13px] font-semibold leading-[16px] text-text-main-lv2">
            {post.authorId}
          </p>
          <p className="text-[12px] leading-[14px] text-text-main-lv4">
            {formatDateTime(post.postedAt, 'PPP')}
          </p>
        </div>
      </div>
      <img src={post.photoUrl} alt="test" className="w-full h-full aspect-square object-cover" />
      <div className="p-[16px] flex flex-col gap-[12px] items-start">
        <div className="flex items-center gap-[10px]">
          <div className="flex items-center gap-[3px]">
            <Like size={25} className="text-text-main-lv2" />
            <span className="text-[13px] font-semibold leading-[16px] text-text-main-lv2">
              {post.likesCount}
            </span>
          </div>
          <button type="button" className="flex items-center gap-[3px]">
            <Chat size={25} className="text-text-main-lv2" />
            <span className="text-[13px] font-semibold leading-[16px] text-text-main-lv2">
              {post.commentsCount}
            </span>
          </button>
        </div>
        <div>
          <p className="text-[13px] font-medium leading-[19px] text-text-main-lv2">
            <span className="font-semibold mr-[8px]">{post.authorId}</span>
            {post.body}
          </p>
        </div>
      </div>
    </div>
  );
};
